import { ApiResponse } from './for-api';

export enum EnumTnCType {
  LoginScreen = 'LoginScreen',
  ProgramSubmit = 'ProgramSubmit',
  ClientLogin = 'ClientLogin',
}

export type TncLike = {
  createdDate: Date;
  content: string;
  type: string;
  version: string;
};

export type NewTnC = TncLike;

export interface TnC extends NewTnC {
  id: string;
}

export type TnCApiResponse = ApiResponse<TnC>;
